import { FC } from "react";

import { mainTheme } from "@data/theme/theme";
import DefaultButton from "@ui/components/Button/DefaultButton";
import Divider from "@ui/components/Divider/Divider";
import DefaultModal from "@ui/components/Modal/DefaultModal";

import DeleteModalList from "./components/DeleteModalLIst";
import {
  GridSpacer,
  DeleteModalContainer,
  DeleteModalFooter,
  DeleteModalHeader,
  DeleteListTitle,
  DeleteModalText,
  ScrollableContent,
  DeleteModalFooterContainer,
  DeleteModalFooterButtonContainer,
} from "./deleteModalStyle";
import { GetWorkspace } from "@data/repositories/Workspace/queryWorkspace";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  deletedWorkspace: GetWorkspace[];
  onSubmit?: () => void;
};

const DeleteConfirmWorkspaceModal: FC<Props> = ({
  isOpen,
  onRequestClose,
  deletedWorkspace,
  onSubmit = () => {},
}) => {
  return (
    <DefaultModal isOpen={isOpen} onRequestClose={() => {}}>
      <DeleteModalContainer>
        <DeleteModalHeader>削除一覧</DeleteModalHeader>

        <DeleteListTitle>
          <GridSpacer />
          <DeleteModalText>走行環境名</DeleteModalText>
          <DeleteModalText>走行環境ID</DeleteModalText>
          <DeleteModalText>会社名</DeleteModalText>
          <DeleteModalText>FMSプロジェクトID</DeleteModalText>
          <GridSpacer />
        </DeleteListTitle>
        <Divider thin="1px" rounded />

        <ScrollableContent>
          <DeleteModalList items={deletedWorkspace} />
        </ScrollableContent>

        <DeleteModalFooter>
          <DeleteModalFooterContainer>
            <GridSpacer />
            <GridSpacer />
            <DeleteModalFooterButtonContainer>
              <DefaultButton
                backgroundColor={mainTheme.colors.secondaryPositive}
                hoverColor={mainTheme.colors.secondary}
                color={mainTheme.colors.onSecondary}
                onClick={onRequestClose}
                buttonText={"キャンセル"}
                size={"XS"}
                contentWidth={"72px"}
              />
              <DefaultButton
                backgroundColor={mainTheme.colors.primaryPositive}
                hoverColor={mainTheme.colors.primary}
                color={mainTheme.colors.onPrimary}
                onClick={onSubmit}
                buttonText={"削除"}
                size={"XS"}
                contentWidth={"72px"}
              />
            </DeleteModalFooterButtonContainer>
            <GridSpacer />
          </DeleteModalFooterContainer>
        </DeleteModalFooter>
      </DeleteModalContainer>
    </DefaultModal>
  );
};

export default DeleteConfirmWorkspaceModal;
